const MsgCounterIcon = () => {
  return (
    <svg
      className="w-4 h-4"
      viewBox="0 0 16 17"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g clipPath="url(#clip0_0_13)">
        <path
          d="M3.88065 3.77338C6.47931 1.93005 10.1933 2.08072 12.596 4.13072C15.0406 6.21538 15.3746 9.62272 13.364 12.0621C11.4693 14.3601 8.05398 15.1174 5.20998 13.9321L5.05531 13.8647L2.13865 14.4854L2.08865 14.4941L2.01531 14.5001L1.93998 14.4974L1.91065 14.4941L1.83731 14.4807L1.76731 14.4581L1.70065 14.4287L1.64998 14.4007L1.57798 14.3494L1.52398 14.3001L1.47531 14.2447L1.43998 14.1947L1.39665 14.1181L1.36865 14.0474L1.34798 13.9721L1.33931 13.9221L1.33331 13.8487L1.33598 13.7734L1.33931 13.7441L1.35265 13.6707L1.36731 13.6227L2.13398 11.3221L2.11931 11.2981C0.64598 8.80005 1.31331 5.70338 3.72665 3.88605L3.87998 3.77405L3.88065 3.77338Z"
          fill="currentColor"
        />
      </g>
      <defs>
        <clipPath id="clip0_0_13">
          <rect
            width="16"
            height="16"
            fill="currentColor"
            transform="translate(0 0.5)"
          />
        </clipPath>
      </defs>
    </svg>
  );
};

export default MsgCounterIcon;
